<template>
    <o-colflex :style="style">
        <o-flexitem flex-basic="need">
            <div :style="{ display: 'flex', padding: '5px' }">
                <div ref="div" :style="{ flex: '1 1 0px', display: 'flex', gap: '5px', overflow: 'hidden' }">
                    <el-tag v-for="tag in tags" type="info">{{ tag }}</el-tag>
                </div>
                <div :style="{ flex: 'none', width: '150px', display: 'flex', gap: '5px', justifyContent: 'right' }">
                    <div v-if="visiable">
                        <el-tooltip effect="light" :teleported="false">
                            <template #default>
                                <o-button size="small" :icon="More" text />
                            </template>
                            <template #content>
                                <el-scrollbar max-height="100">
                                    <el-tag v-for="tag in tags" type="info" :style="{ margin: '5px' }">
                                        {{ tag }}
                                    </el-tag>
                                </el-scrollbar>
                            </template>
                        </el-tooltip>
                    </div>
                    <div>
                        <o-button type="primary" size="small" @click="selectDone">确定</o-button>
                    </div>
                    <div>
                        <o-button size="small" @click="clearSelection">清空</o-button>
                    </div>
                </div>
            </div>
        </o-flexitem>
        <o-flexitem>
            <pagetable ref="table" :data="data" selection-mode size="small" :pagination-teleported="false"
                :pagination-show-jumber="false" @select="onSelect" @select-all="onSelectAll" v-bind="$attrs">
                <slot></slot>
            </pagetable>
        </o-flexitem>
    </o-colflex>
</template>
<script setup lang="ts">
import Pagetable from '../Pagetable'
import { ElTag, ElTooltip, ElScrollbar } from 'element-plus'
import { More } from '@element-plus/icons-vue'
import { computed, nextTick, onMounted, ref, useTemplateRef, watch } from 'vue'
import { find, intersectionWith, isEqual, remove } from 'lodash-es'
import { addUnit } from '../_util'
import { useTableselect } from '../Input'

defineOptions({ name: 'OTableselectPagetable', inheritAttrs: true })

const { data, width = 600, height = 300 } = defineProps<{ data: any[], width: number | string, height: number | string }>()
const style = computed(() => {
    return {
        width: addUnit(width),
        height: addUnit(height)
    }
})
const tableRef = useTemplateRef('table')
const selection = ref<any[]>([])
const tags = computed(() => selection.value.map((item) => tableselect?.tag(item)))

const visiable = ref(false)
const divRef = useTemplateRef('div')
onMounted(() => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type == 'childList') {
                const target = mutation.target as HTMLDivElement
                if (target.scrollWidth > target.clientWidth) {
                    visiable.value = true
                } else {
                    visiable.value = false
                }
            }
        });
    });
    observer.observe(divRef.value!, {
        childList: true
    });
})

const onSelect = (_selection: any[], _row: any) => {
    if (find(_selection, _row)) {
        if (!find(selection.value, _row)) {
            selection.value.push(_row)
        }
    } else {
        if (find(selection.value, _row)) {
            remove(selection.value, _row)
        }
    }
    tableselect?.onSelect(selection.value)
}
const onSelectAll = (_selection: any[]) => {
    if (_selection.length > 0) {
        _selection.forEach((item) => {
            if (!find(selection.value, item)) {
                selection.value.push(item)
            }
        })
    } else {
        remove(selection.value, (item) => find(data, item))
    }
    tableselect?.onSelect(selection.value)
}

const tableselect = useTableselect()
const selectDone = () => {
    tableselect?.selectDone()
}
const clearSelection = () => {
    uncheckSelection()
    selection.value = []
    tableselect?.onSelect([], true)
}

watch(
    () => data,
    async () => {
        if (data.length > 0) {
            await nextTick()
            checkSelection()
        }
    }
)
watch(() => tableselect?.selection, () => {
    if (tableselect?.selection && tableselect.selection.length > 0) {
        selection.value = tableselect.selection
        checkSelection()
    }
})

const checkSelection = () => {
    const _selection = intersectionWith(data, selection.value, isEqual)
    _selection.forEach((row) => {
        //@ts-ignore
        tableRef.value!.toggleRowSelection(row, true)
    })
}

const uncheckSelection = () => {
    const _selection = intersectionWith(data, selection.value, isEqual)
    _selection.forEach((row) => {
        //@ts-ignore
        tableRef.value!.toggleRowSelection(row, false)
    })
}
</script>